import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants.js";

const translation = {
  consentModal: {
    title: "Avviso sui file cookie",
    description:
      "Utilizziamo file cookie essenziali per garantire che questo sito web funzioni correttamente. Utilizziamo anche file cookie di tracciamento opzionali per aiutarci a capire come interagisci con il nostro sito. Questi file cookie opzionali verranno impostati solo con il tuo consenso.",
    acceptAllBtn: "Accetta tutto",
    acceptNecessaryBtn: "Rifiuta tutto",
    showPreferencesBtn: "Gestisci preferenze individuali",
  },
  preferencesModal: {
    title: "Gestisci preferenze dei file cookie",
    acceptAllBtn: "Accetta tutto",
    acceptNecessaryBtn: "Rifiuta tutto",
    savePreferencesBtn: "Accetta selezione corrente",
    closeIconLabel: "Chiudi finestra",
    sections: [
      {
        title: "Uso dei file cookie",
        description:
          "Utilizziamo file cookie per supportare le funzioni essenziali di questo sito web e per migliorare la tua esperienza di navigazione.",
      },
      {
        title: "File cookie strettamente necessari",
        description:
          "Questi file cookie sono essenziali per il corretto funzionamento del sito web, ad esempio per l’autenticazione degli utenti.",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: {
            name: "Nome",
            domain: "Servizio",
            description: "Descrizione",
            expiration: "Scadenza",
          },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description:
                "File cookie impostato dalla Piattaforma Digitale della Comunità per l’autenticazione dell’utente.",
              expiration: "Sessione",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description:
                "File cookie impostato dalla Piattaforma Digitale della Comunità per l’autenticazione dell’utente",
              expiration: "Sessione",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "Questo file cookie è utilizzato per distinguere tra esseri umani e bot e per proteggere il sito da abusi automatizzati. Nessun dato personale viene raccolto.",
              expiration: "30 minuti",
            },
          ],
        },
      },
      {
        title: "Analisi",
        description:
          "I file cookie utilizzati per l’analisi aiutano a raccogliere dati che permettono ai servizi di capire come gli utenti interagiscono con un determinato servizio. Queste informazioni consentono di migliorare i contenuti e di sviluppare funzionalità migliori che migliorano l’esperienza utente.",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: {
            name: "Nome",
            domain: "Servizio",
            description: "Descrizione",
            expiration: "Scadenza",
          },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'File cookie impostato da <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "Scade dopo 12 giorni",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'File cookie impostato da <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "Sessione",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel =
  "Abilita la memorizzazione relativa all’analisi, ad esempio la durata della visita.";

export { translation, servicesLabel };
